import React, { useEffect, useState } from "react";
import WorkshopCard from "../WorkshopCard/WorkshopCard";
import { open_api, open_api_with_cookies } from "../../Utils/network";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../WorkshopCard/workshopCard.module.css";

function ExpertDetailsWorkshop({ slug }) {
  const [workShopList, setWorkshopList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      getWorkshop(slug);
    }
  }, [slug]);

  function CustomPrevArrow(props) {
    const { onClick } = props;
    return (
      <button
        className={`${styles.customarrow} ${styles.customprevarrow}`}
        onClick={onClick}
      >
        <ArrowBackIosNewIcon />
      </button>
    );
  }

  function CustomNextArrow(props) {
    const { onClick } = props;
    return (
      <button
        className={`${styles.customarrow} ${styles.customnextarrow}`}
        onClick={onClick}
      >
        <ArrowForwardIosIcon />
      </button>
    );
  }

  const settings = {
    className: styles.slickstyles,
    dots: true,
    autoplay: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    autoplaySpeed: 3000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const getWorkshop = (id) => {
    setLoading(true);
    open_api_with_cookies
      .get(`profiles/experts/${id}/workshops`)
      .then((res) => {
        if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
          setWorkshopList(res?.data?.results || []);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching workshops:", err);
        setLoading(false);
      });
  };

  if (loading) {
    return <div>Loading workshops...</div>;
  }

  if (!workShopList || workShopList.length === 0) {
    return <div>No workshops available</div>;
  }

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {workShopList.map((workshop, index) => (
          <div key={index} className={styles.sliderItem}>
            <WorkshopCard data={workshop} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ExpertDetailsWorkshop;
